import firebase from 'firebase/app'
import { auth, db, storage, firestore } from '../../plugins/firebase'
import { userAtLeastIs, LEVEL_ADMIN } from '../../plugins/checkPermission'

const state = {
    list: [],
    collection: null,
    selected: null,
    ready: false
}

const getters = {
    getGateway: state => 
        gtw => {
            return state.list.find( g => g.id === gtw )
        }
}

const actions = {
    async init({ commit, dispatch, rootState }){
        return new Promise(async (resolve, reject) => {
            if(auth.currentUser){
                commit('UPDATE_COLLECTION', rootState.account.id)
                await dispatch('fetchUserGateways')
                commit('SET_READY', true)
                return resolve()
            }else{
                commit('UPDATE_COLLECTION')
                commit('SET_GATEWAYS', [])
                return resolve()
            }
        })
    },
    async fetchUserGateways({commit, state, rootState}){
        return new Promise(async (resolve, reject) => {
            try {
                let docs = []
                if(userAtLeastIs(rootState.account.level, LEVEL_ADMIN)){
                    const res = await db.collection(state.collection).get()
                    docs = res.docs.map( doc => ({ id: doc.id, ...doc.data() }) )
                }else{
                    const plants = []
                    for (var i = 0; i < rootState.user.profile.plants.length; i+= 10){
                        plants.push(rootState.user.profile.plants.slice(i, i + 10));
                    }
                    
                    const requests = plants.map( plant_chunk => 
                        db.collection(state.collection)
                        .where(firestore.FieldPath.documentId(), 'in', plant_chunk)
                        .get()
                    )
                    
                    const response = await Promise.all(requests)
                    
                    response.forEach( res => 
                        docs.push( ...res.docs.map( doc => ({ id: doc.id, ...doc.data() }) ))
                    )
                    
                }

                docs.sort((a, b) => a.name.localeCompare(b.name, undefined, {'numeric': true}))

                let gateways = docs.map(async doc => {
                    try {
                        const url = await storage
                            .ref(`users_solar/${rootState.account.id}/${doc.image}`)
                            .getDownloadURL()
                        return { ...doc, url_img: url }
                    } catch (error) {
                        return { ...doc, url_img: null }
                    }
                })

                commit('SET_GATEWAYS', await Promise.all(gateways))
                return resolve()
            } catch (error) {
                console.log(error)
                return reject({ message: '¡Ops! Ocurrio un error' })
            }
        })
    },
    async updatedGatewaySelected({ commit, state }, gateway_id){
        return new Promise((resolve, reject) => {
            let exist = state.list.find( g => g.id === gateway_id)
            if( exist === undefined && gateway_id !== null ) return resolve()
            commit('SET_SELECTED', gateway_id)
            return resolve()
        })
    },
    async addGateway({ commit, state, rootState }, payload){
        const { gateway, data, meters } = payload
        
        return new Promise(async (resolve, reject) => {
            try {
                let image = data.image
                data.image = `${gateway.id}.${image.name.split('.')[1]}`
                let coordinates = data.location.split(',').map( l => parseFloat(l))
                data.location = new firebase.firestore.GeoPoint(coordinates[0], coordinates[1])
                
                await storage
                    .ref(`users_solar/${rootState.account.id}/${data.image}`)
                    .put(image)
               
                const url_img  = await storage
                    .ref(`users_solar/${rootState.account.id}/${data.image}`)
                    .getDownloadURL()

                await db.doc(`${state.collection}/${gateway.id}`).set({
                    ...data,
                    key: gateway.key
                })

                commit('ADD_GATEWAY', {...data, ...gateway, url_img })
                return resolve()
            } catch (error) {
                console.log(error)
                return reject()
            }
        })
    },
    async editGateway({ commit, state, rootState }, payload){
        const { gateway, data, meters } = payload

        return new Promise(async (resolve, reject) => {
            try {
                let coordinates = data.location.split(',').map( l => parseFloat(l))
                data.location = new firebase.firestore.GeoPoint(coordinates[0], coordinates[1])
                
                let url_img = null
                if(data.image){
                    let image = data.image
                    data.image = `${gateway.id}.${image.name.split('.')[1]}`
                    
                    await storage
                        .ref(`users_solar/${rootState.account.id}/${data.image}`)
                        .put(image)
                
                    url_img  = await storage
                        .ref(`users_solar/${rootState.account.id}/${data.image}`)
                        .getDownloadURL()
                    
                }else
                    delete data.image

                await db.doc(`${state.collection}/${gateway.id}`).update(data)

                if(url_img) commit('EDIT_GATEWAY', {...data, ...gateway, url_img })
                else commit('EDIT_GATEWAY', {...data, ...gateway })

                return resolve()
            } catch (error) {
                console.log(error)
                return reject()
            }
        })
    },
    async deleteGateway({ commit, state }, gateway){
        return new Promise(async (resolve, reject) => {
            try {
                await db.doc(`${state.collection}/${gateway.id}`).delete()
                commit('DELETE_GATEWAY', gateway)
            } catch (error) {
                console.log(error)
                return reject()
            }
        })
    },
    async saveSimulation({ commit }, payload){
        const { start, rate, period, gateway } = payload
        return new Promise(async (resolve, reject) => {
            try {
                await db.doc(`${state.collection}/${gateway}`).update({
                    start_period: start, period, rate
                })
    
                commit('SAVE_SIMULATION', { start_period: start, period, rate, gateway })
                return resolve()
            } catch (error) {
                console.log(error)
                return reject()
            }
        })
    }
}

const mutations = {
    UPDATE_COLLECTION(state, user){
        user 
            ? state.collection = `users_solar/${user}/gateways`
            : state.collection = null
    },
    SET_GATEWAYS(state, payload){
        state.list = payload
    },
    ADD_GATEWAY(state, payload){
        state.list.push(payload)
    },
    EDIT_GATEWAY(state, payload){
        const index = state.list.findIndex( g => g.id === payload.id)
        state.list[index] = payload
    },
    DELETE_GATEWAY(state, gateway){
        const index = state.list.findIndex( g => g.id === gateway.id)
        state.list.splice(index, 1)
    },
    SET_SELECTED(state, payload){
        state.selected = payload
        const index = state.list.findIndex( g => g.id === payload.gateway)
    },
    SAVE_SIMULATION(state, payload){
        const index = state.list.findIndex( g => g.id === payload.gateway)
        state.list[index].start_period = payload.start_period
        state.list[index].period = payload.period
        state.list[index].rate = payload.rate
    },
    SET_READY(state, payload){
        state.ready = payload
    },
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}